import { Link } from '@hotjar/hotsauce';
import { useHelpHotjarUrl } from '@hotjar/translations';
import { FilterKindEnum } from '../../../../domains/global-filters/model/FilterChain';
import { getLabels } from '../../../../utils/LabelFormatter/SingleLabelFormatter/ClickedLabelFormatter';
import { getFilterMetadata } from '../../FilterChainUtils';
import type { DateRange, MinimalDateConstraint } from '../DateRangeFilter/DateRangeFilterType';
import { GenericFilter } from '../GenericBloc/GenericFilter/GenericFilter';
import type { AbstractSingleFilterPillsProps } from '../SingleFilterType';
import { ClickedFilterDropdown } from './ClickedFilterDropdown';
import type { ClickedType } from './ClickedFilterType';

interface ClickedFilterProps extends AbstractSingleFilterPillsProps<ClickedType> {
  dateConstraint?: MinimalDateConstraint;
  dateRange?: DateRange;
  isFunnelStep?: boolean;
}

export function ClickedFilter({
  autoFocus,
  currentValue,
  onApply,
  onRemove,
  onDropdownHidden,
  showDropdownOnMount,
  dateConstraint,
  dateRange,
  isFunnelStep,
}: ClickedFilterProps): JSX.Element {
  const helpHotjarUrl = useHelpHotjarUrl();
  const metadata = getFilterMetadata(FilterKindEnum.Clicked);
  const { label1, label2 } = getLabels(currentValue);
  const handleApply = (close: () => void, newValue?: ClickedType) => {
    onApply(newValue);
    close();
  };

  return (
    <GenericFilter
      autoFocus={autoFocus}
      filterName={metadata.filterName}
      label1={label1}
      label2={label2}
      iconName={metadata.iconName}
      onRemove={onRemove}
      showDropdownOnMount={showDropdownOnMount}
      onDropdownHidden={onDropdownHidden}
      isFunnelStep={isFunnelStep}
      renderDropdown={({ close }) => {
        return (
          <ClickedFilterDropdown
            filterName={metadata.filterName}
            currentValue={currentValue}
            onApply={(newValue) => handleApply(close, newValue)}
            header={
              <span>
                Sessions where a user clicked on an element, such as a button or link.{' '}
                <Link kind="inline" href={`${helpHotjarUrl}/articles/8917152574743`} isExternal>
                  More about clicked element
                </Link>
              </span>
            }
            dateConstraint={dateConstraint}
            dateRange={dateRange}
            isFunnelStep={isFunnelStep}
          />
        );
      }}
    />
  );
}
